<script setup>
import { ref } from 'vue';
import { useAuthStore, useReadinessStore, useAppStore } from '../stores';
import ResourcesActivitiesList from '../components/ResourcesActivitiesList.vue';
const showFilters = ref(false);
const authStore = useAuthStore()
const readinessStore = useReadinessStore()
const appStore = useAppStore()

</script>
<template>
    <div class="grid grid-cols-1 md:grid-cols-2 px-2 w-full bg-white absolute z-10 h-dvh" v-if="showFilters" :style="`height: calc(100dvh - ${appStore.avaialableScreenHeight}`"
            enter="transform ease-out duration-300 transition" enter-from="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-4"
          enter-to="translate-y-0 opacity-100 sm:translate-x-0" leave="transition ease-in duration-500"
          leave-from="opacity-100" leave-to="opacity-0" move="transition duration-500" move-delay="delay-300">
        <div class="row fixed top-28 right-4">
            <button @click="showFilters = !showFilters" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-2 rounded-full h-10 w-10">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" class="w-6 h-6 text-white">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
        <div class="block mx-2 bg-white rounded-xl shadow-md flex flex-col justify-start content-center my-2">
            <div class="font-semibold ">
                Pending Milestones
            </div>
            <div class="grid grid-cols-2">
                <div v-for="child in authStore.sortedChildren" class="flex flex-row w-full items-between pt-1">
                    <input :id="`${child.id}`" :name="`child-filter-${child.id}`" type="checkbox" :checked="readinessStore.filterByChildIds.includes(child.id)"
                        @click="readinessStore.toggleChildFilter(child.id)"
                        class="w-4 h-4 text-secondary bg-gray-200 border-gray-300 rounded focus:ring-secondary focus:ring-2 rounded-full pr-2">
                    <label :for="`child-filter-${child.id}`"
                        class="ml-2 text-sm text-gray-500">{{ child.first_name }}</label>
                </div>
            </div>
        </div>
        <div
            class="block mx-2 mt-2 text-tealr p-4 bg-white rounded-xl bg-blue shadow-md  flex flex-col justify-start content-center mb-2">
            <div class="font-semibold ">
                Developmental Area
            </div>
            <div>
                <div v-for="area in Object.values(readinessStore.readinessAreas)"
                    class="flex flex-row w-full items-between pt-1">
                    <input :id="`${area.id}`" :name="`area-filter-${area.id}`" type="checkbox" :value="area.id"
                        @click="readinessStore.toggleAreaFilter(area.id)" :checked="readinessStore.filterByAreaIds.includes(area.id)"
                        class="w-4 h-4 text-secondary bg-gray-200 border-gray-300 rounded focus:ring-secondary focus:ring-2 rounded-full pr-2">
                    <label :for="`child-filter-${area.id}`"
                        class="ml-2 text-sm text-gray-500">{{ area.title }}</label>
                </div>
            </div>
        </div>
        <div
            class="block mx-2 mt-2 text-tealr p-4 bg-white rounded-xl bg-blue shadow-md  flex flex-col justify-start content-center mb-2">
            <div class="font-semibold ">
                Readiness Guide
            </div>
            <div class="grid grid-cols-2">
                <div v-for="guide in Object.values(readinessStore.readinessGuides)"
                    class="flex flex-row w-full items-between pt-1">
                    <input :id="`${guide.id}`" :name="`guide-filter-${guide.id}`" type="checkbox" :value="guide.id"
                        @click="readinessStore.toggleGuideFilter(guide.id)" :checked="readinessStore.filterByGuideIds.includes(guide.id)"
                        class="w-4 h-4 text-secondary bg-gray-200 border-gray-300 rounded focus:ring-secondary focus:ring-2 rounded-full pr-2">
                    <label :for="`child-filter-${guide.id}`"
                        class="ml-2 text-sm text-gray-500">{{ guide.title.replace('Readiness Guide', '') }} ({{ guide.months_marker }} months)</label>
                </div>
            </div>
        </div>
    </div>
    <div>
        <div @click="showFilters = !showFilters" class="mt-2 mx-2">
            <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" :class="{hidden: showFilters}">
                Activity Filters
            </button>
        </div>
    </div>
    <div class="relative overflow-x-auto shadow-md sm:rounded-lg ">
        <Suspense>
            <template #fallback>
                Loading
            </template>
            <template #default>
                <ResourcesActivitiesList  class=""/>
            </template>
        </Suspense>
    </div>
</template>